import { Result } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import "../../styles/component/error.scss";


const Error = () => {

  return (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
            <Link to={"/"} className="back-home-button">
            Back Home
          </Link>
        }
      />
  );
};

export default Error;
